import { Breadcrumbs, BreadcrumbItem } from "@nextui-org/react";
import CardDescargaNifs from "../componentes/configuracion/cardDescargaNifs";

const Configuracion = () => {
    return (
        <section>
        <Breadcrumbs isDisabled className="mb-6">
            <BreadcrumbItem>Principal</BreadcrumbItem>
            <BreadcrumbItem active>Configuración</BreadcrumbItem>
        </Breadcrumbs>
        <h2 className="text-xl">
            Gestiona la configuración 
        </h2>
        <p className="text-gray-400 text-[13px]">Gestiona las opciones relacionadas con el servicio</p>
        <div className="py-3">
            <CardDescargaNifs />
        </div>
    
    </section>
    );
    }
    export default Configuracion;